/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVendorWorkspaceUserDto } from '../../models/create-vendor-workspace-user-dto';
import { VendorWorkspaceUserDto } from '../../models/vendor-workspace-user-dto';

export interface VendorWorkspaceUserControllerCreateMember$Params {

/**
 * 입점사 ID
 */
  id: string;
      body: CreateVendorWorkspaceUserDto
}

export function vendorWorkspaceUserControllerCreateMember(http: HttpClient, rootUrl: string, params: VendorWorkspaceUserControllerCreateMember$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceUserDto>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceUserControllerCreateMember.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorWorkspaceUserDto>;
    })
  );
}

vendorWorkspaceUserControllerCreateMember.PATH = '/api/vendorWorkspaceUser/{id}/users';
